import { Navigate } from 'react-router-dom';
import { MarketShareReport } from '@/features/market-share';
import { useDrug } from '@/features/drugs/api/use-drug';
import { useParams } from '@/router';
import { Card } from '@/components-new/card';
import { drugName } from '@/utils/drugs';
import { useMarketShareReportFeature } from '@shared/feature-flags';
import { useMarketShareDrugs } from '@/features/market-share/api/use-market-share-drugs';

// RF 1-29-2025: This page is currently not in use.
export default function DrugMarketShareReportPage() {
  const { id: drugId } = useParams('/drugs/:id');
  const { data: drug } = useDrug(drugId);
  const { data: marketShareDrugs, isLoading: marketShareDrugsLoading } = useMarketShareDrugs();
  const isMarketShareReportEnabled = useMarketShareReportFeature();

  if (!isMarketShareReportEnabled) {
    return <Navigate to={`/drugs/${drugId}`} replace />;
  }

  if (!drug) {
    return (
      <Card className="p-6">
        <div className="text-gray-500">Loading drug information...</div>
      </Card>
    );
  }

  if (marketShareDrugsLoading) {
    return (
      <Card className="p-6">
        <div className="text-gray-500">Loading market share data...</div>
      </Card>
    );
  }

  return (
    <MarketShareReport
      preSelectedDrugId={drug.id}
      preSelectedDrugName={drugName(drug)}
      showDrugSelection={false}
      title={`Market Share Report - ${drugName(drug)}`}
      description={`Detailed market share analysis for ${drugName(drug)} including utilization trends and competitive positioning.`}
      className="max-w-none"
    />
  );
}
